<template>
  <li
    :class="clickableClass"
    data-cy="profile-dropdown-options"
  >
    <div
      v-if="icon"
      class="icon-container"
    >
      <v-icon>
        {{ icon }}
      </v-icon>
    </div>

    <sn-avatar
      v-if="showAvatar"
      class="mr-2"
      :icon="icon"
      :image="image"
      :initials="mainTextInitials"
      size="xxs"
    />
    <div class="option-titles">
      <sn-tooltip
        direction="bottom"
        :disabled="disableTooltip"
      >
        <template v-slot:activator="{on}">
          <div
            v-on="on"
          >
            <p :class="`${mainTextClass} ${clickableClass}`">
              {{ mainText }}
            </p>
          </div>
        </template>
        <span class="sn-font-primary sn-font-weight-regular sn-text-white">{{ mainText }}</span>
      </sn-tooltip>
      <p
        v-if="subtext !== null"
        class="subtext"
      >
        {{ subtext }}
      </p>
    </div>
  </li>
</template>

<script>

export default {
  name: 'ProfileDropdownOption',
  props: {
    mainText: {
      type: String,
      default: '',
      required: true
    },
    subtext: {
      type: String,
      default: '',
      required: false
    },
    showAvatar: {
      type: Boolean,
      default: true,
      required: false
    },
    icon: {
      type: String,
      default: '',
      required: false
    },
    image: {
      type: String,
      default: '',
      required: false
    },
    bold: {
      type: Boolean,
      default: false,
      required: false
    },
    clickable: {
      type: Boolean,
      default: true,
      required: false
    }
  },
  computed: {
    mainTextClass () {
      return this.bold ? 'main-text bold' : 'main-text regular'
    },
    clickableClass () {
      return this.clickable ? 'clickable' : 'cursor-default'
    },
    mainTextInitials () {
      return this.mainText
        .split(' ')
        .slice(0, 2) // max 2 words may be displayed as initials
        .map(word => word[0])
        .join('')
        .toUpperCase()
    },
    disableTooltip () {
      return this.bold ? this.mainText.length < 19 : this.mainText.length < 21
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~/assets/css/snui';

li {
  display: inline-flex;
  font-family: $font-family-primary;
  list-style-type: none;
  text-align: left;
  padding: 10px 16px;
  min-height: 40px;

  &.clickable {
    &:hover {
      background: rgba(15, 95, 94, 0.05);
    }
  }

  p {
    margin: 0;
    padding: 0;
  }

  .option-titles {
    display: flex;
    flex-direction: column;
  }
}

.clickable {
  cursor: pointer;
}

.main-text {
  font-size: 17px;
  line-height: 24px;
  max-width: 190px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.bold {
  font-weight: $font-weight-bold;
  cursor: default;
}

.regular {
  max-width: 184px;
}

.cursor-default {
  cursor: default !important;
}

.subtext {
  font-size: 13px;
  line-height: 18px;
}

.icon-container {
  display: flex;
  justify-content: center;
  width: 32px;
  margin-right: 8px;
}
</style>
